import React from 'react';
import { Check } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import forYouImg from '../../assets/landing/father_and_sister.webp';
import logoWhite from '../../assets/logos/SVG/BLANCO/logo scribane_blanco micro simple.svg';

const GREEN = 'var(--scribane-green)';

function BoldInline({ text }: { text: string }) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return (
    <span>
      {parts.map((part, i) =>
        part.startsWith('**') && part.endsWith('**')
          ? <strong key={i}>{part.slice(2, -2)}</strong>
          : part
      )}
    </span>
  );
}

const FOR_WHO_ITEMS = [
  'landing_early_access_for_1',
  'landing_early_access_for_2',
  'landing_early_access_for_3',
  'landing_early_access_for_4',
  'landing_early_access_for_5',
  'landing_early_access_for_6',
] as const;

/* Pen-nib icon — matches the Scribane brand mark */
function NibIcon() {
  return (
    <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M12 0L22 10L12 20L2 10L12 0Z" fill="white" fillOpacity="0.9"/>
      <rect x="10" y="18" width="4" height="14" rx="2" fill="white" fillOpacity="0.9"/>
    </svg>
  );
}

export const EarlyAccess: React.FC = () => {
  const { t } = useLocale();

  return (
    <section id="for-you" className="scroll-mt-24" style={{ background: '#E0E0E0' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1.2fr',
      }} className="for-you-card">

          {/* Left — photo + overlay + text */}
          <div style={{
            position: 'relative',
            minHeight: '600px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            padding: '40px 36px',
          }}>
            {/* Photo */}
            <img
              src={forYouImg}
              alt=""
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
            {/* Dark scrim */}
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(to top, rgba(39,39,41,0.75) 35%, rgba(39,39,41,0.25) 100%)',
            }} />
            {/* Text */}
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ marginBottom: '20px' }}>
                <img src={logoWhite} alt="Scribane" style={{ width: '48px', height: 'auto' }} />
              </div>
              <h2 style={{
                fontFamily: "'Inter', system-ui, sans-serif",
                fontWeight: 300,
                fontSize: 'clamp(32px, 4vw, 52px)',
                lineHeight: 1.06,
                letterSpacing: '-0.02em',
                color: '#fff',
                margin: '0 0 16px',
              }}>
                {t('landing_for_who_title_prefix')}
                <strong style={{ fontWeight: 800, display: 'block' }}>
                  {t('landing_for_who_title_suffix')}
                </strong>
              </h2>
              <p style={{
                fontFamily: "'Inter', system-ui, sans-serif",
                fontSize: '14px',
                lineHeight: '20px',
                fontWeight: 400,
                color: 'rgba(255,255,255,0.7)',
                margin: 0,
                maxWidth: '320px',
              }}>
                {t('landing_early_access_description')}
              </p>
            </div>
          </div>

          {/* Right — checklist */}
          <div style={{
            background: '#E0E0E0',
            padding: '44px 40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <ul style={{
              listStyle: 'none',
              margin: 0,
              padding: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              width: '100%',
              maxWidth: '500px',
            }}>
              {FOR_WHO_ITEMS.map((key) => (
                <li key={key} style={{
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'flex-start',
                  fontSize: '14px',
                  lineHeight: '20px',
                  color: '#272729',
                }}>
                  <Check size={15} style={{ color: GREEN, flexShrink: 0, marginTop: '2px' }} />
                  <BoldInline text={t(key)} />
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Responsive */}
        <style>{`
          @media (max-width: 860px) {
            .for-you-card { grid-template-columns: 1fr !important; }
            .for-you-card > div:first-child { min-height: 320px !important; }
          }
        `}</style>
    </section>
  );
};
